// CSV helpers for Hub ▸ Marketing downloads — pure, no imports, so the API's
// offline gate (qa-marketing-s2) runs them.
//
// Spreadsheet formula injection: a cell that starts with = + - @ (or a tab /
// carriage return) is run as a formula by Excel / Sheets. Campaign and client
// names come from outside (ad platforms, CSV uploads, website forms), so any
// such text cell is prefixed with an apostrophe. Plain numbers (including
// negative amounts like -12.50) are left as numbers.

const FORMULA_START = /^[=+\-@\t\r]/;
const NUMBER = /^-?\d+(\.\d+)?$/;

export function csvCell(v: unknown): string {
  let s = v == null ? "" : String(v);
  if (FORMULA_START.test(s) && !NUMBER.test(s)) s = `'${s}`;
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function toCsv(head: string[], rows: unknown[][]): string {
  return [head, ...rows].map((r) => r.map(csvCell).join(",")).join("\n") + "\n";
}
